<template>
    <div>
        <h1 class="title">Not Found</h1>
        <p>Woops! Looks like the page you requested cannot be found.</p>
    </div>
</template>

<script>
export default {};
</script>
